// extracted by css-extract-rspack-plugin
export default {"icon":"Icon-module__icon--Tuc1A"};